import { jsonp, ajax } from '@ifeng/ui_base';
import { formatImage, formatUrl } from '@ifeng/public_method';
import { getSkey, handleNewstime } from '../utils/utils';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;

/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const md5 = require('md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

/* 公共 */

// 获取调查数据
const getSurveyData = async (id, index = 0) => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: createJsonpCallbackName(id, index),
        cache: false,
    });
    const requestUrl = `sv.ifeng.com/index.php/survey/getdata?id=${id}&callback=getSurveyData`;

    data = schemaCheck(data, 'surveyDataSchema', requestUrl);

    return data ? data : null;
};

/**
 *  时尚首页
 */

/**
 * 音乐首页
 * @param {String} dataType 数据类型: yueNews, yueAi, yueNishizhen
 */
const getYueNews = async dataType => {
    const data = await jsonp(`${apiBaseUrl}/yue/index/${dataType}/getYueNews`, {
        jsonpCallback: 'getYueNews',
        cache: 120,
    });

    const dataArr = data.data.data;

    const result = dataArr.slice(0, 10);

    return result ? result : null;
};
const getYueAi = async dataType => {
    const data = await jsonp(`${apiBaseUrl}/yue/index/${dataType}/getYueAi`, {
        jsonpCallback: 'getYueAi',
        cache: 120,
    });

    const dataArr = data.data.data;

    const result = dataArr.slice(0, 15);

    return result ? result : null;
};
const getYueNishizhen = async dataType => {
    const data = await jsonp(`${apiBaseUrl}/yue/index/${dataType}/getYueNishizhen`, {
        jsonpCallback: 'getYueNishizhen',
        cache: 120,
    });

    const dataArr = data.data.data;

    const result = dataArr.slice(0, 12);

    return result ? result : null;
};
// 获取文章评论数
const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

/**
 *  凤凰私家相册
 * @param {String} dataType 数据类型: getbanner...
 * http://apidoc.ifeng.com/index.php?s=/33&page_id=769
 */

const getImemoryData = async (dataType, dataObj) => {
    try {
        const data = await jsonp(`//api.imemory.ifeng.com/${dataType}`, {
            data: dataObj ? dataObj : {},
            jsonpCallback: 'callback',
            cache: false,
        });

        return data;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 提交调查
 * @param {String} id 调查id
 * @param {String} sur 选项拼接字符串
 */
const postSurvey = async (id, sur) => {
    try {
        const data = await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${sur}`, {
            data: { id },
            jsonpCallback: 'callback',
            cache: false,
        });

        return data;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取热点调查
 * @param {String} type
 * @param {Number} num
 */
const getSurveyHot = async (type = 'hot', num = 5) => {
    try {
        const res = await jsonp('//sv.ifeng.com/index.php/survey/getsort', {
            data: { type, num },
            jsonpCallback: 'callback',
            cache: false,
        });

        if (res.ifsuccess) {
            return res.data;
        }
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取卫视英文页文章
 * @param {String} id
 */

const getTvArticle = async id => {
    try {
        const res = await jsonp(`${apiBaseUrl}/phtv/index/getArticleData/${id}/getTvArticle`, {
            jsonpCallback: 'getTvArticle',
            cache: false,
        });

        return res.data;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取卫视英文页人员介绍结构化碎片数据
 * @param {String} id
 */

const getTvStruct = async id => {
    try {
        const res = await jsonp(`${apiBaseUrl}/phtv/index/getStructData/${id}/getTvStruct`, {
            jsonpCallback: 'getTvStruct',
            cache: false,
        });

        return res.data;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取卫视英文页联系方式
 * @param {String} id
 */

const getTvStatic = async id => {
    try {
        const res = await jsonp(`${apiBaseUrl}/phtv/index/getStaticData/${id}/getTvStatic`, {
            jsonpCallback: 'getTvStatic',
            cache: false,
        });

        return res.data;
    } catch (e) {
        console.error(e);
    }
};

const getUid = () => {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;

        return v.toString(16);
    });
};

/**
 * 获取餐厅列表
 * @param {*} params { pageNumber, pageSize, type, area, searchValue }
 */
const getRestaurantList = async params => {
    return await ajax(`${apiBaseUrl}/getRestaurantList/${getUid()}`, {
        data: params,
        type: 'post',
        cache: false,
    });
};

const getRestaurantInfo = async id => {
    return await jsonp(`${apiBaseUrl}/getGourmetFestivalDocData/${id}/getRestaurantInfo`, {
        jsonpCallback: 'getRestaurantInfo',
        cache: false,
    });
};

const getiVideoData = async id => {
    const jsonpCallback = createJsonpCallbackName(id, new Date().getTime());

    return await jsonp(`${apiBaseUrl}/getVideoData/${id}/${jsonpCallback}`, {
        jsonpCallback,
        cache: false,
    });
};

export {
    getSurveyData,
    getYueNews,
    getYueAi,
    getYueNishizhen,
    getCommentCount,
    getImemoryData,
    postSurvey,
    getSurveyHot,
    getTvArticle,
    getTvStruct,
    getTvStatic,
    getRestaurantList,
    getRestaurantInfo,
    getiVideoData,
};
